import React from "react";
import { useContext } from "react";
import { useTranslation } from 'react-i18next';
import GroupIcon from '@mui/icons-material/Group';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

const translations = {
  en: require('../../../Translate/en.json').WebsiteDevelopment.WhoWeAre,
  ar: require('../../../Translate/ar.json').WebsiteDevelopment.WhoWeAre,
};

const WhoWeAre = () => {
  const { i18n } = useTranslation();
    const isLang = i18n.language;
  const t = translations[isLang || "en"];

  return (
    <div className="who-we-are-modern">
      <div className="modern-card">
        <div className="card-icon">
          <GroupIcon style={{ fontSize: "25px", color: "#ff7849" }} />
        </div>
        <h2 className="modern-card-title">{t.WhoWeAreSection.title}</h2>
        <p className="modern-card-description">{t.WhoWeAreSection.description}</p>
      </div>

      <div className="modern-card">
        <div className="card-icon">
          <LightbulbIcon style={{ fontSize: "25px", color: "#ff7849" }} />
        </div>
        <h2 className="modern-card-title">{t.WhyRightClick.title}</h2>
        <p className="modern-card-description">{t.WhyRightClick.description}</p>
      </div>
    </div>
  );
};

export default WhoWeAre;
